import type { App } from 'vue'
import type { Router } from 'vue-router'
import * as Sentry from '@sentry/vue'

export default (app: App, router: Router) => {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    initialScope: {
      tags: {
        application: import.meta.env.VITE_SENTRY_APP
      },
    },
  })
}
